export enum TipoPropostaEnum {
  NOVA_ADESAO = 1,
  INCLUSAO_CARENCIA = 2,
  SUMULA = 3,
  PORTABILIDADE = 4,
  RECEM_NASCIDO = 5,
  RECEM_CASADO = 6,
  INCLUSAO_DEPENDENTE = 7,
  REDUCAO_CARENCIA = 8,
}

const descricao = new Map<TipoPropostaEnum, string>([
  [TipoPropostaEnum.NOVA_ADESAO, 'Nova Adesão'],
  [TipoPropostaEnum.INCLUSAO_CARENCIA, 'Inclusão com Carencias'],
  [TipoPropostaEnum.SUMULA, 'Súmula 21'],
  [TipoPropostaEnum.PORTABILIDADE, 'Portabilidade'],
  [TipoPropostaEnum.RECEM_NASCIDO, 'Inclusão com Recem-nascido'],
  [TipoPropostaEnum.RECEM_CASADO, ' Inclusão de Recem-casado'],
  [TipoPropostaEnum.INCLUSAO_DEPENDENTE, ' Inclusão de Dependente'],
  [TipoPropostaEnum.REDUCAO_CARENCIA, 'Redução Carência'],
]);

export class TipoPropostaEnumDescription {
  static getDescricao(valor: TipoPropostaEnum): string {
    return descricao.get(valor) || '';
  }

  static getAll(): {valor: TipoPropostaEnum; descricao: string}[] {
    return Array.from(descricao.entries()).map(([valor, descricao]) => ({
      valor,
      descricao,
    }));
  }
}
